exports = module.exports = require("../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".demo-icon-home{background-image:url(" + require("../assets/images/home/home.png") + ");background-size:100%}.demo-icon-search{background-image:url(" + require("../assets/images/home/search.png") + ");background-size:100%}.demo-icon-noti{background-image:url(" + require("../assets/images/home/button.png") + ");background-size:100%}.demo-icon-me{background-image:url(" + require("../assets/images/home/person.png") + ");background-size:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4aa206a4","scoped":false,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/demos/Page.vue
// module id = gv8v
// module chunks = 1